import React from 'react';
import HeaderMobile from './mobile';
import HeaderDesktop from './desktop';
import { IHeaderProps } from '@components/header/types';
import useBreakpoints from '@hooks/useBreakpoints';
import useStore from '@hooks/useStore';

const Header: React.FC<IHeaderProps> = (props) => {
  const { isTouchScreen } = useBreakpoints();
  const { sura } = useStore();

  return sura.isSura ? (
    <HeaderDesktop {...props} />
  ) : isTouchScreen ? (
    <HeaderMobile {...props} />
  ) : (
    <HeaderDesktop {...props} />
  );
};

export default Header;
